import { render, staticRenderFns } from "./IntroductionHabitation.vue?vue&type=template&id=1ee65e8b&"
import script from "./IntroductionHabitation.vue?vue&type=script&lang=js&"
export * from "./IntroductionHabitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports